import script from "./TopLayoutClient.vue?vue&type=script&setup=true&lang=js"
export * from "./TopLayoutClient.vue?vue&type=script&setup=true&lang=js"

import "./TopLayoutClient.vue?vue&type=style&index=0&id=adaadc6e&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adaadc6e"]])

export default __exports__